import { defineMessage } from 'services/localization';

export const messages = {
    invalidConditions: defineMessage('please_ensure_that_all_set_conditions_are_valid'),
    done: defineMessage('done'),
    xeroDataSyncButtonTitle: defineMessage('pull_values_from_xero'),
    netSuiteDataSyncButtonTitle: defineMessage('pull_values_from_oracle_netsuite'),
};
